import React, { Fragment,Component } from 'react';
import sgen from '../images/sgen.png';
import linkcheck from '../images/LinkCheck.jpeg';
import houseof from '../images/HouseOf_medium.png';
import openai from '../images/OpenAI_Logo.png'
import { Link } from 'react-router-dom';

class tools extends Component {
    render() {
        return (
            <Fragment>
                <div className='img-container'>
                    <img src={houseof} alt="house"/>
                </div>
                <div className="body-container">
                    <br/>
                    <div className="CenteredTitle">Our Tools</div>
                    <br/>
                    <div className='grid-2'>
                        <div className='card'>
                            <div className='cardContents'>
                            <img src={sgen} alt="sgen"/>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='cardContents'>
                                <div className="text-center">
                                    <div className="CenteredTitle">SGEN</div><br/>
                                    Script Generator allows users to easily create test scripts and view them in a table view for easy sharing.
                                    With our easy to use interface, SGEN helps you create a test suite with minimum effort.
                                    <br/><br/>Note sure what to write? Don’t worry, SGEN writes test cases for you with as little as a component name and type.
                                    Try it today and see how easy it can be to create your next test suite.
                                    <br/><br/>
                                    Now Powered by 
                                    <div className="all-center ">
                                    <div className="img-container-med"><img src={openai} alt="openAI"/></div>
                                    </div>
                                    <br/><br/>
                                    <a href="http://sgen.mytestingtools.com/">Let's write some test cases!</a>   
                                    <br/><br/>
                                    <Link to="/documentation">Teach me how to use the tool!</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='grid-2'>
                        <div className='card'>
                            <div className='cardContents'>
                            <img src={linkcheck} alt="linkcheck"/>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='cardContents'>
                                <div className="text-center">
                                    <div className="CenteredTitle">LinkCheck</div><br/>
                                    An application that scans your webpage for broken links, missing images and terms/expressions.
                                    A useful tool for all professionals who want to make sure their websites are displaying valid links. 
                                    Loading images correctly and word search capability as well as emailing results available in the Pro version.
                                    <br/><br/>
                                    <a href="https://apps.apple.com/us/app/link-check-lite/id1230814915">Available in the App Store now!</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default tools



// WEBPACK FOOTER //
// ./src/components/layout/tools.js